import type {CreatePaymentWayRequest} from '@rocket-ui/lk-api';
import {extractCardDigits, isCardNumberValid} from './cardNumber';
import type {SelectedBank} from './selectedBank';

type BuildCardPaymentWayParams = {
	card: string;
	selectedBank: SelectedBank | null;
	isPrimary?: boolean;
};

export function buildCardPaymentWayRequest({
	card,
	selectedBank,
	isPrimary = false,
}: BuildCardPaymentWayParams): CreatePaymentWayRequest | null {
	const bik = selectedBank?.bik?.trim();
	const cardNumber = extractCardDigits(card);

	if (!bik || !isCardNumberValid(cardNumber)) {
		return null;
	}

	return {
		type: 'bank_card',
		bik,
		cardNumber,
		isPrimary,
	};
}
